/*
 * Copyright © 2023 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {PersonalPermissionSet} from '@dv/shared/backend/model/personal-permission-set';

export const PERSONAL_PERMISSION_SET_HIERARCHY = [
    PersonalPermissionSet.ADMINISTRATE,
    PersonalPermissionSet.MANAGE,
    PersonalPermissionSet.VIEW,
];

export function isPersonalPermissionSet(value: unknown): value is PersonalPermissionSet {
    return Object.values(PersonalPermissionSet).includes(value as PersonalPermissionSet);
}
